<template lang="pug">
.modal-wrapper
  .button-wrapper
    b-button(icon-left="download" type="is-light" @click="openModal('copy')") {{destination}} von anderem Objekt kopieren
    b-button(icon-left="upload" type="is-light" @click="openModal('paste')") {{destination}} in ein anderes Objekt einfügen

  b-modal(v-model="isComponentModalActive"
          has-modal-card
          :full-screen="false" 
          :can-cancel="true")
    .modal-card(style="width: auto")  
      header.modal-card-head
        p.modal-card-title(v-if="mode === 'copy'") {{destination}} von anderem Objekt kopieren
        p.modal-card-title(v-else) {{destination}} in ein anderes Objekt einfügen
      section.modal-card-body
        b-table(:data="rentObjects"
                      default-sort-direction="asc"
                      default-sort="date"
                      hoverable)
          b-table-column(field='code' label='Code' width='40' sortable centered searchable v-slot="props")
            | {{ props.row.code }}
          b-table-column(label='Typ' width='40' sortable, v-slot="props")
            b-field
              b-icon(:icon="props.row.rentObjectType.icon")
              p.icon-name {{props.row.rentObjectType.name}}
          b-table-column(field='name' label='Titel' sortable, v-slot="props")
            | {{ props.row.name }}
          b-table-column(label='Aktionen', v-slot="props")
            .button-wrapper
              b-button(v-if="mode === 'copy'" type="is-primary" @click="copyFromObject(props.row.id)") Kopieren
              template(v-else)
                b-icon(icon="check" type="is-success" v-if="alreadyPasted(props.row.id)")
                b-button(v-else type="is-primary" @click="pasteToObject(props.row.id)") Einfügen
</template>

<script>
export default {
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    rentObjectType: {
      type: Object,
      default: null
    },
    destination: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      isComponentModalActive: false,
      mode: "copy",
      pastedObjects: [] // this way one can track better what objects he pasted
    }
  },
  computed: {
    rentObjects() {
      return this.$store.state.rentObjects.all.filter(r => r.rentObjectTypeId === this.rentObjectType.id);
    },
    rentObjectTypes() {
      return this.$store.state.rentObjectTypes.all;
    }
  },
  methods: {
    openModal(mode) {
      this.mode = mode;
      this.isComponentModalActive = true;
    },
    async copyFromObject(fromId) {
      await this.$store.dispatch("rentObjects/copy", {
        fromId,
        toId: this.id,
        destination: this.destination
      });
      this.isComponentModalActive = false;
      this.$emit("copySuccess");
    },
    async pasteToObject(toId) {
      await this.$store.dispatch("rentObjects/paste", {
        fromId: this.id,
        toId,
        destination: this.destination
      });
      this.pastedObjects.push(toId);
    },
    alreadyPasted(id) {
      const obj = this.pastedObjects.find(pId => pId === id);
      return !!obj;
    }
  },
  mounted() {
    this.$store.dispatch("rentObjects/findAll");
    this.$store.dispatch("rentObjectTypes/findAll");
  }
}
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
</style>